import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";
import NodeCloneIdentityPolicy from "models/audioEditor/sequencerNodes/NodeCloneIdentityPolicy";

// Same test the newer editor applies to a saved persistentNodeId: a 36-character UUID v4.
const PERSISTENT_NODE_ID_UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
const PERSISTENT_NODE_ID_LENGTH = 36;

function isValidPersistentNodeId(value){
    return typeof value === "string" && value.length === PERSISTENT_NODE_ID_LENGTH
        && PERSISTENT_NODE_ID_UUID_V4_PATTERN.test(value);
}

// This editor never creates persistent node ids, but projects saved by the newer editor carry
// one on every node, and agent suggestion lists and word references point at them. A clone made
// to save the project stands for the same node, so it keeps the id. Any other clone (copy/paste,
// replacement) is a new node and gets no id; the newer editor gives it a fresh one on load.
function applyCloneIdentityPolicyToAttributes(cloneAttributes, sourceNode, cloneIdentityPolicy){
    if(cloneIdentityPolicy === NodeCloneIdentityPolicy.PreserveIdentity){
        const sourcePersistentNodeId = sourceNode.get("persistentNodeId");
        if(isValidPersistentNodeId(sourcePersistentNodeId)){
            cloneAttributes.persistentNodeId = sourcePersistentNodeId;
        }
    }
    return cloneAttributes;
}



const SequencerNodeCloner =  Backbone.Model.extend({
    idAttribute: "id",


    

    cloneLinkedSequencerNodes : function(
        sequencerNodeToStartCloningAt,
        sequencerNodeToStopCloningAt,
        sequencerNodeCidToCloneNodeMap,
        cloneIdentityPolicy,
    ){
        if(!sequencerNodeCidToCloneNodeMap){
            sequencerNodeCidToCloneNodeMap = {}
        }
        const resolvedCloneIdentityPolicy = cloneIdentityPolicy || NodeCloneIdentityPolicy.RegenerateIdentity;
        const firstNodeCid = sequencerNodeToStartCloningAt.cid;
        let sequencerNodeToClone = sequencerNodeToStartCloningAt;
        let lastSequencerNodeToClone = null;
        const nodeCidToOriginalSequencerNode = {};
        while(sequencerNodeToClone){
            if(sequencerNodeToClone === sequencerNodeToStopCloningAt || !sequencerNodeToClone.getNext()){
                lastSequencerNodeToClone = sequencerNodeToClone;
                sequencerNodeToClone = null;
            }else{
                sequencerNodeToClone = sequencerNodeToClone.getNext();
            }
        }
        sequencerNodeToClone = lastSequencerNodeToClone;
        const nodeCidCloned = [];
        while(sequencerNodeToClone){
            const existingClone  = sequencerNodeCidToCloneNodeMap[sequencerNodeToClone.cid];
            if(!existingClone){
                const contructorClass = sequencerNodeToClone.getConstructor();
                const cloneAttributes = applyCloneIdentityPolicyToAttributes(
                    sequencerNodeToClone.cloneJSON(),
                    sequencerNodeToClone,
                    resolvedCloneIdentityPolicy,
                );
                const newClone =  new contructorClass(cloneAttributes,null, true, sequencerNodeToClone, sequencerNodeCidToCloneNodeMap);
                nodeCidToOriginalSequencerNode[sequencerNodeToClone.cid] = sequencerNodeToClone;
                sequencerNodeCidToCloneNodeMap[sequencerNodeToClone.cid] = newClone;
                nodeCidCloned.push(sequencerNodeToClone.cid);
            }
            if(sequencerNodeToClone !== sequencerNodeToStartCloningAt){
                sequencerNodeToClone = sequencerNodeToClone.getPrevious();
            }else{
                sequencerNodeToClone = null;
            }
        }
        for(let nodeCid in nodeCidToOriginalSequencerNode){
            const originalSequencerNode = nodeCidToOriginalSequencerNode[nodeCid];
            const clonedSequencerNode = sequencerNodeCidToCloneNodeMap[nodeCid];
            originalSequencerNode.afterInstanceCreatedFromConstructorForCloning(
                clonedSequencerNode,
                sequencerNodeCidToCloneNodeMap,
                resolvedCloneIdentityPolicy,
            );
        }
        let nodeCidToLink = firstNodeCid;
        while(nodeCidToLink){
            let nextNodeCidToLink = nodeCidToOriginalSequencerNode[nodeCidToLink].getNext()? nodeCidToOriginalSequencerNode[nodeCidToLink].getNext().cid: null;
            const sequencerNodeToLinkWith = sequencerNodeCidToCloneNodeMap[nodeCidToLink];
            if(nextNodeCidToLink){
                const nextNodeToLinkWith = sequencerNodeCidToCloneNodeMap[nextNodeCidToLink];
                if(nextNodeToLinkWith){
                    sequencerNodeToLinkWith.setNext(nextNodeToLinkWith);
                }else{
                    nextNodeCidToLink = null;
                }
            }
            nodeCidToLink =  nextNodeCidToLink;
            if(sequencerNodeToStopCloningAt && nodeCidToLink === sequencerNodeToStopCloningAt.cid){
                nodeCidToLink = null;	
            }
        }
        const firstSequenerNodeClone = sequencerNodeCidToCloneNodeMap[firstNodeCid];

        return firstSequenerNodeClone;

    },

    


});


const sequencerNodeClonerInstance = new SequencerNodeCloner();

export default {
    getInstance : function() {
        return sequencerNodeClonerInstance;
    }
};
